import { string } from "prop-types";


const CONFIG = {
  // Local
  APP_ROOT: process.env.MIX_APP_URL as string,

  // API
  API_ROOT: process.env.MIX_API_ROOT as string,
  API_BASE_URL: process.env.MIX_API_BASE_URL as string,

  // Other
  WEB_URL_ROOT: process.env.MIX_WEB_URL_ROOT as string,

  // Algolia
  ALGOLIA_APP_ID: process.env.MIX_ALGOLIA_APP_ID as string,
  ALGOLIA_SEARCH_API_KEY: process.env.MIX_ALGOLIA_SEARCH_KEY as string,

  // Cloudinary
  CLOUDINARY_URL: process.env.MIX_CLOUDINARY_URL as string,
  CLOUDINARY_UPLOAD_PRESET: process.env.MIX_CLOUDINARY_UPLOAD_PRESET as string, //TODO not used
  CLOUDINARY_NOTIFICATION_URL: process.env.MIX_CLOUDINARY_NOTIFICATION_URL as string, //TODO: not used
  CLOUDINARY_CLOUD_NAME: process.env.MIX_CLOUDINARY_CLOUD_NAME as string,
  CLOUDINARY_API_KEY: process.env.MIX_CLOUDINARY_API_KEY as string, //TODO not used

  // Google
  GOOGLE_RECAPTCHA_KEY: process.env.MIX_GOOGLE_RECAPTCHA_KEY as string
}

export default CONFIG;
